import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Divider,
    HStack,
    Icon,
    Input,
    InputGroup,
    InputLeftElement,
    Select,
    SimpleGrid,
    Spinner,
    Text,
    useColorModeValue,
    VStack,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { FiCalendar, FiDownload, FiRefreshCw } from 'react-icons/fi';
import { AccessExportFilters, useAccessExport } from '../hooks/useAccessExport';

const storeOptions = [
  { value: '', label: 'Todas as lojas' },
  { value: 'loja-principal', label: 'Loja Principal' },
  { value: 'loja-secundaria', label: 'Loja Secundária' },
  { value: 'italia-consulado', label: 'Itália Consulado' },
];

const AccessExport: React.FC = () => {
  const [exportFilters, setExportFilters] = useState<AccessExportFilters>({});
  const { isExporting, exportAccessData } = useAccessExport();

  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const cardBg = useColorModeValue('blue.50', 'blue.900');
  const cardBorder = useColorModeValue('blue.200', 'blue.600');

  const handleFilterChange = (field: keyof AccessExportFilters, value: string) => {
    setExportFilters(prev => ({
      ...prev,
      [field]: value || undefined
    }));
  };

  const handleExport = () => {
    exportAccessData(exportFilters);
  };

  const handleClearFilters = () => {
    setExportFilters({});
  };

  const hasFilters = Object.values(exportFilters).some(Boolean);

  return (
    <Card 
      bg={cardBg} 
      borderColor={cardBorder} 
      borderWidth="1px"
      borderStyle="solid"
    >
      <CardHeader pb={2}>
        <HStack spacing={3} align="center">
          <Icon as={FiDownload} boxSize={5} color="blue.500" />
          <Text fontSize="lg" fontWeight="bold" color="blue.700">
            📊 Exportar Controle de Acesso
          </Text>
        </HStack>
        <Text fontSize="sm" color="gray.600" mt={1}>
          Gera um arquivo Excel com dados organizados por pessoas
        </Text>
      </CardHeader>

      <Divider borderColor={cardBorder} />

      <CardBody>
        <VStack spacing={4}>
          {/* Filtros de Exportação */}
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} w="100%">
            {/* Seletor de Loja */}
            {/* <VStack align="start" spacing={2}>
              <Text fontSize="sm" fontWeight="medium" color="gray.700">
                Loja (opcional)
              </Text>
              <Select
                placeholder="Selecionar loja"
                value={exportFilters.store || ''}
                onChange={(e) => handleFilterChange('store', e.target.value)}
                bg={bgColor}
                borderColor={borderColor}
                _focus={{ borderColor: 'blue.400', boxShadow: '0 0 0 1px blue.400' }}
                size="sm"
              >
                {storeOptions.slice(1).map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Select>
            </VStack> */}

            {/* Data Início */}
            <VStack align="start" spacing={2}>
              <Text fontSize="sm" fontWeight="medium" color="gray.700">
                Data Início (opcional)
              </Text>
              <InputGroup>
                <InputLeftElement>
                  <Icon as={FiCalendar} color="gray.400" />
                </InputLeftElement>
                <Input
                  type="date"
                  value={exportFilters.startDate || ''}
                  onChange={(e) => handleFilterChange('startDate', e.target.value)}
                  bg={bgColor}
                  borderColor={borderColor}
                  _focus={{ borderColor: 'blue.400', boxShadow: '0 0 0 1px blue.400' }}
                  size="sm"
                />
              </InputGroup>
            </VStack>

            {/* Data Fim */}
            <VStack align="start" spacing={2}>
              <Text fontSize="sm" fontWeight="medium" color="gray.700">
                Data Fim (opcional)
              </Text>
              <InputGroup>
                <InputLeftElement>
                  <Icon as={FiCalendar} color="gray.400" />
                </InputLeftElement>
                <Input
                  type="date"
                  value={exportFilters.endDate || ''}
                  onChange={(e) => handleFilterChange('endDate', e.target.value)}
                  bg={bgColor}
                  borderColor={borderColor}
                  _focus={{ borderColor: 'blue.400', boxShadow: '0 0 0 1px blue.400' }}
                  size="sm"
                />
              </InputGroup>
            </VStack>
          </SimpleGrid>

          {/* Informações do Arquivo */}
          <VStack 
            p={3} 
            bg={useColorModeValue('gray.50', 'gray.700')} 
            borderRadius="md" 
            w="100%" 
            align="start"
          >
            <Text fontSize="xs" fontWeight="semibold" color="gray.600" textTransform="uppercase">
              Arquivo Gerado:
            </Text>
            <Text fontSize="sm" color="gray.700">
              📄 controle_acesso_por_pessoas_{new Date().toISOString().split('T')[0]}.xlsx
            </Text>
            <Text fontSize="xs" color="gray.500">
              O Excel contém: resumo por pessoa, detalhes dos acessos e tempo total de permanência
            </Text>
          </VStack>

          {/* Botões de Ação */}
          <HStack spacing={3} w="100%" justify="flex-end">
            <Button
              leftIcon={<FiRefreshCw />}
              variant="outline"
              onClick={handleClearFilters}
              isDisabled={!hasFilters || isExporting}
              size="md"
              borderColor="gray.300"
            >
              🔄 Limpar Filtros
            </Button>
            <Button
              leftIcon={isExporting ? <Spinner size="sm" /> : <FiDownload />}
              colorScheme="blue"
              onClick={handleExport}
              isLoading={isExporting}
              loadingText="Gerando Excel..."
              size="md"
              shadow="md"
            >
              📊 Exportar por Pessoas
            </Button>
          </HStack>
        </VStack>
      </CardBody>
    </Card>
  );
};

export default AccessExport; 